import { api } from '@cloudsuite/theme_library/scripts/helper';

const config = {
    showLoggedOutNotification: true,
    showLoggedInNoglobaltification: true,
    customerUsesMultipleLanguages: true,
    language: $('#enterpriseDomain').val().split('_')[0]
};

const global = {
    wishlistName: (config.customerUsesMultipleLanguages ? `cs_wishlist_${config.language}` : 'cs_wishlist'),
    enterpriseDomain: (config.customerUsesMultipleLanguages ? document.getElementById('enterpriseDomain').value : ''),
}

const storage = localStorage;
const wishlistContainer = $('.js-wishlist-fill');
const realWishlistContainer = $('.js-real-wishlist');
const isUserLoggedIn = () => js_translations.userLoggedIn;
const doesWishlistCookieExist = () => storage.getItem(global.wishlistName) !== null && storage.getItem(global.wishlistName) !== '';
let productList = [];

const createWishlistCookie = () => {
    storage.setItem(global.wishlistName, '{"products": []}');
}

const encodeCookie = json => {
    let cookie = JSON.stringify(json);
    return cookie;
}

const decodeCookie = cookie => {
    let json = JSON.parse(cookie);
    return json;
}

const addProductstoRealWishlist = (products) => {
    products.forEach(product => {
        $.get(`/templates/add_whishlist/${product.id}/`, function () {
            if (config.showLoggedInNotification) {
                $.notify({
                    message: product.message
                }, {
                    type: 'info',
                    delay: 1000
                });
            }
        });
    });
}

const deleteWishlistBadge = () => {
    $('.js-wishlist-link .badge').remove();
}

const createWishlistBadge = (count) => {
    if (count > 99) {
        return `<div class="badge"><span>99+</span></div>`;
    } else {
        return `<div class="badge"><span>${count}</span></div>`;
    }
} 

const showWishlistNotification = () => {        
    storage.setItem('wishlist_notif', true);

    $('.wishlist-notication').fadeIn();
}

const initWishlist = () => {
    if (!isUserLoggedIn() && !doesWishlistCookieExist()) {
        createWishlistCookie();
        productList = JSON.parse(localStorage.getItem(global.wishlistName));
        productList.products.forEach(wlproduct => {
            const text = $(`[data-id=${wlproduct.id}]`).attr('data-inWishlistTitle');
            $(`[data-id=${wlproduct.id}]`).find('.far').toggleClass('far fas');
            $(`[data-id=${wlproduct.id}]`).find('small').text(text);
        });

    } else if (isUserLoggedIn() && doesWishlistCookieExist() && wishlistContainer.length) {
        showWishlistProducts();
        productList = decodeCookie(storage.getItem(global.wishlistName));
        addProductstoRealWishlist(productList.products);
        productList.products.forEach(wlproduct => {
            const text = $(`[data-id=${wlproduct.id}]`).attr('data-inWishlistTitle');
            $(`[data-id=${wlproduct.id}]`).find('.far').toggleClass('far fas');
            $(`[data-id=${wlproduct.id}]`).find('small').text(text);
        });

    } else if (isUserLoggedIn() && doesWishlistCookieExist() && !wishlistContainer.length) {
        productList = decodeCookie(storage.getItem(global.wishlistName));
        addProductstoRealWishlist(productList.products);

        const wishlistbadge = $('.js-wishlist-link');
        const cookieWishlistCount = decodeCookie(storage.getItem(global.wishlistName)).products.length;
        const currentcount = parseInt($(wishlistbadge).find('.badge').data('count') || 0);
    
        if(!$(wishlistbadge).find('.badge').length > 0) {
            $(wishlistbadge).append(`<div class="badge"><span></span></div>`);
        }
        if(wishlistbadge) {
            $(wishlistbadge).find('.badge').html(`<span>${currentcount + cookieWishlistCount}</span>`);
            $(wishlistbadge).find('.badge').data('count', currentcount + cookieWishlistCount);
        }
        if ($('.js-real-wishlist').length) {

            const products = productList.products;
            products.forEach(product => {
                $('.js-real-wishlist').prepend(`<div class="col-xs-6 col-sm-4 col-md-3 col-lg-15"> ${createProductTile(product)} </div>`);
                $('.js-real-wishlist').find('.col-xs-12').remove();
            })
        }
        storage.setItem(global.wishlistName, '{"products": []}');
    } else if (!isUserLoggedIn() && doesWishlistCookieExist()) {
        productList = JSON.parse(localStorage.getItem(global.wishlistName));
        productList.products.forEach(wlproduct => {
            const text = $(`[data-id=${wlproduct.id}]`).attr('data-inWishlistTitle');
            $(`[data-id=${wlproduct.id}]`).find('.far').toggleClass('far fas');
            $(`[data-id=${wlproduct.id}]`).find('small').text(text);
        });

        if (localStorage.getItem('wishlist_notif') && decodeCookie(storage.getItem(global.wishlistName)).products.length == 1) {
            $('.wishlist-notication').fadeIn();
        } 
    }
}

const removeProductFromWishlist = (productid) => {
    let backupstorage = storage.getItem(global.wishlistName);
    let backupproducts = decodeCookie(backupstorage);

    backupproducts.products.forEach((product, index) => {
        if (product.id == productid) {
            backupproducts.products.splice(index, 1);
        }
    })

    if ($('.js-wishlist-link')) {
        deleteWishlistBadge();

        if (backupproducts.products.length > 0) {
            $('.js-wishlist-link').append(createWishlistBadge(backupproducts.products.length));
        }
    }
    storage.setItem(global.wishlistName, encodeCookie(backupproducts))
}

const addProductToWishlistCookie = product => {
    const CURRENTWISHLIST = decodeCookie(storage.getItem(global.wishlistName));
    CURRENTWISHLIST.products.push(product);
    let newWishlist = CURRENTWISHLIST;

    try {
        storage.setItem(global.wishlistName, encodeCookie(newWishlist));
        if ($('.js-wishlist-link .badge').hasClass('hidden')) {
            $('.js-wishlist-link .badge').removeClass('hidden');
        }

        if ($('.js-wishlist-link')) {
            // deleteWishlistBadge();

            if (decodeCookie(storage.getItem(global.wishlistName)).products.length > 0) {

                // Show Wishlist notification
                if (decodeCookie(storage.getItem(global.wishlistName)).products.length == 1) {
                    setTimeout(() => {
                        showWishlistNotification();
                    }, 5000);
                }

                $('.js-wishlist-link').append(createWishlistBadge(decodeCookie(storage.getItem(global.wishlistName)).products.length));
            }
        }
        if (config.showLoggedOutNotification) {
            $.notify({
                message: product.message
            }, {
                type: 'info',
                delay: 1000
            });
        }
    } catch (error) {
        console.error(error);
    }
}

const isProductInWishlist = productid => {
    let index,
        wishlist = decodeCookie(storage.getItem(global.wishlistName)),
        productList = wishlist.products;

    for (index = 0; index < productList.length; index++) {
        if (productList[index].id === productid) {
            return true;
        }
    }
    return false;
}

$(document).on('click', '.js-wishlist-cookie-add', async function (e) {
    e.preventDefault();

    let $this = $(this);
    let product = $this.attr('data-product');
    const product_attributes = $this.data('ega');
    const backupProduct = product;
    let message = $this.attr('data-product-added-message');   
    const productData = JSON.parse(product);

    const button = e.target.offsetParent
    button.disabled = true

    const categories =  await api.get($this.data("tree-parents-url").replace('999999', productData.tree))
    .then((trees) => {
        return trees.map(tree => tree.name).join('/');
    });

    setTimeout(() => {
        if ($this.find('.listview-heart').hasClass('fas') && !$this[0].hasAttribute('data-js-hotspot-wishlist')) {

            const dataDelivery = () => {
                if ($('[data-js-ga-delivery-days]')) {
                    return {
                    'delivery_text': $this.closest('.data-js-product').find("[data-js-ga-delivery-days] p").text() || null,
                    'delivery_days': $this.closest('.data-js-product').find("[data-js-ga-delivery-days]").attr('data-js-ga-dd') || null,
                    'stock_text': $this.closest('.data-js-product').find("[data-js-ga-delivery-days] [data-js-ga-stock-msg]").attr('data-js-ga-stock-msg') || null,
                    'stock_quantity': $this.closest('.data-js-product').find("[data-js-ga-delivery-days] [data-js-ga-stock-msg]").attr('data-js-ga-stock') || null,
                    }
                }
            }

            const clickTrigger = () => {
                const triggerEvent = $this.attr('data-js-ga-trigger');
                let triggerValue;
                if (window.innerWidth < 768) {
                  triggerValue = `${triggerEvent}_mobile`;
                } else {
                  triggerValue = `${triggerEvent}_desktop`;
                }
          
                return triggerValue;
            }
    
            dataLayer.push({
                'event': 'addToWishlist',
                'location': window.location.href,
                ...$this.attr('data-js-ga-trigger') ? {details: clickTrigger()} : [],
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'add': { // 'add' actionFieldObject measures.
                        'actionField': undefined,
                        'products': [
                            {
                                "name": productData.name,
                                "id": productData.code,
                                "price": `${productData.sale_price_no_format.toFixed(2)}`,
                                "brand": productData.brand,
                                ...(categories && {"category": `${categories}/${productData.tree_name}`}),
                                ...(product_attributes && product_attributes.kleur ? {"kleur": product_attributes.kleur} : []),
                                ...(product_attributes && product_attributes.kleurstaal ? {"kleurstaal": product_attributes.kleurstaal} : []),
                                ...(product_attributes && product_attributes.material ? {"material": product_attributes.material} : []),
                                ...(product_attributes && product_attributes.stijl ? {"stijl": product_attributes.stijl} : []),
                                "variant": productData.name_with_attributes
                            }
                        ]
                    }
                },
                ...dataDelivery()
            });
        }
    }, 100);

    if (!isProductInWishlist(JSON.parse(product).id)) {
        //add
        product = createShortProduct(product, message);
        addProductToWishlistCookie(product);
        $this.find('small').text($this.attr('data-inWishlistTitle'));
    } else {
        //remove
        let productid = $this.attr('data-id');
        removeProductFromWishlist(productid);
        $this.find('small').text($this.attr('data-outWishlistTitle'));
        showWishlistProducts();
        if (config.showNotification) {
            $.notify({
                message: "Product verwijderd"
            }, {
                type: 'info',
                z_index: 99999999,
                delay: 1000
            });
        }
    }
    if ($this.attr('data-extra-url')) {
        window.location.href = $this.attr('data-extra-url');
    }
    let changeTitle = isProductInWishlist(JSON.parse(backupProduct).id) ? $this.find('i').attr('data-inWishlistTitle') : $this.find('i').attr('data-outWishlistTitle');
    $(`.js-wishlist-cookie-add[data-id=${$(this).attr('data-id')}]`).find('i, span').attr('title', changeTitle);
    $(`.js-wishlist-cookie-add[data-id=${$(this).attr('data-id')}]`).find('i, span').attr('data-original-title', changeTitle);
    $(`.js-wishlist-cookie-add[data-id=${$(this).attr('data-id')}]`).find('i, span').toggleClass('fas far');

    button.disabled = false;
});

const showWishlistProducts = () => {
    if (wishlistContainer && wishlistContainer.length) {
        if (doesWishlistCookieExist()) {
            let json = decodeCookie(storage.getItem(global.wishlistName));
            let products = json.products;
            wishlistContainer.html('');
            if (products.length) {
                products.forEach(product => {
                    wishlistContainer.prepend(`<div class="col-xs-6 col-sm-4 col-md-3 col-lg-15 product-col"> ${createProductTile(product)} </div>`);
                })
                const ALL_POPOVERS = document.querySelectorAll('.cs-popover-toggle');
                ALL_POPOVERS.forEach(popover => {
                    popover.addEventListener('click', function (e) {
                        e.stopPropagation();
                        const POPOVER = e.currentTarget.parentNode.querySelector('.cs-popover');
                        POPOVER.classList.toggle('open');
                    });
                });
                $('.js-wishlist-no-products').hide();
            } else {
                $('.js-wishlist-no-products').show();
            }
        }
    }
}

$(document).on('click', '.js-remove-cookie-wishlist', function (e) {

    let productid = $(this).attr('data-productid');
    removeProductFromWishlist(productid);
    showWishlistProducts();
});

// if (!isUserLoggedIn()) {
//     let productList = JSON.parse(localStorage.getItem(global.wishlistName));
//     if (productList) {
//         productList.products.forEach(wlproduct => {
//             const text = $(`[data-id=${wlproduct.id}]`).attr('data-inWishlistTitle');
//             $(`[data-id=${wlproduct.id}]`).find('.far').toggleClass('far fas');
//             $(`[data-id=${wlproduct.id}]`).find('small').text(text);
//         });
//     }
// }

$('.js-wishlist-login-modal').on('click', function (e) {
    e.preventDefault();
    $($(this).data('target')).find('[name=return_url]').val($(this).data('return-url'));
    $($(this).data('target')).modal();
})

// Close wishlist notification
const closeButtonWishlist = document.querySelectorAll('[js-wishlist-notication-close]');
if (closeButtonWishlist.length) {
    closeButtonWishlist.forEach(btn => {
        btn.addEventListener('click', (e) => {
            if (e.currentTarget.classList.contains('wishlist-notication__close')) {
                e.currentTarget.parentNode.style.display = 'none';
            }
            
            localStorage.removeItem('wishlist_notif');
        });
    })
}

const createShortProduct = (product, message = "Product succesvol toegevoegd!") => {
    let newProduct = {};
    product = JSON.parse(product);

    newProduct.id = product.id;
    newProduct.name = product.name;
    newProduct.slug = product.slug;
    newProduct.code = product.code;
    newProduct.brand = product.brand;
    newProduct.picture = {};
    newProduct.picture.normal = product.picture.normal;
    newProduct.consumer_price = (product.consumer_price ? product.consumer_price.replace('€', '') : "");
    newProduct.sale_price = (product.sale_price ? product.sale_price.replace('€', '') : "");
    newProduct.variant_name = product.variant_name;
    newProduct.stock = product.stock;
    newProduct.category = product.tree_name;

    newProduct.message = message;

    return newProduct;
}


const createProductTile = (product) => {


    const outletProduct = ['S', 'M', "O"].indexOf(product.code.slice(0,1)) == -1;

    const dataEga = {
        'name': product.name,
        'id': product.code || product.id,
        'price': product.sale_price ? product.sale_price : 0,
        'brand': product.brand || 'No brand',
        'category': product.category,
        'variant': product.variant_name,
    }

    product.showButton = (!(js_translations.userLoggedIn == true && js_translations.template_state) ? 'hidden' : '');
    return `
    <div class="product" data-ega='${JSON.stringify(dataEga)}'>
        <div class="product__top">
            <i class="gorb gorb-close-cross js-remove-cookie-wishlist delete-wishlist" style="cursor: pointer;" data-productid="${product.id}"></i>
            <div class="cs-popover-container">
                <div class="cs-popover-toggle">
                    <span>${js_translations.shareWishlishText}</span>
                    <button class="wishlist-heart">
                        <img src="/static/themes/goossens/img/icon-share.svg" height=20 alt="Share">
                    </button>
                    <div class="cs-popover">
                        <div class="content">
                            <p>${js_translations.shareMainText}</p>
                            <a class="visible-xs" target="_blank" href="whatsapp://send?text=${js_translations.shareWhatsappText}%20${js_translations.baseUrl}/p/${product.slug}/${product.id}?utm_source=whatsapp%26utm_medium=social%26utm_campaign=product_delen%26utm_content=${product.code}">
                                <img src="/static/themes/goossens/img/icon-whatsapp_2.svg" alt="Whatsapp">
                            </a>
                            <a class="hidden-xs" target="_blank" href="http://www.facebook.com/sharer.php?u=${js_translations.baseUrl}/p/${product.slug}/${product.id}">
                                <img src="/static/themes/goossens/img/icon-facebook.svg" alt="Facebook">
                            </a>
                            <a class="hidden-xs" target="_blank" href="http://pinterest.com/pin/create/link/?url=${js_translations.baseUrl}/p/${product.slug}/${product.id}&description=${product.name? product.name : product.variant}&image_url=${js_translations.baseUrl}${product.picture.normal?product.picture.normal: `/static/themes/goossens/img/default_product.png`}">
                                <img src="/static/themes/goossens/img/icon-pinterest.svg" alt="Pinterest">
                            </a>
                            <a class="hidden-xs" target="_blank" href="mailto:?subject=${js_translations.baseUrl}/p/${product.slug}/${product.id}&body={{ mailText|replace(' ', '%20') }}%20${js_translations.baseUrl}/p/${product.slug}/${product.id}">
                                <img src="/static/themes/goossens/img/icon-mail.svg" alt="Mail">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="inner">
            <div class="inner__top">
                <div class="image">
                    <a href="/p/${product.slug}/${product.id}">
                        <img class="img-responsive lazyload" data-src="${product.picture.normal}" alt="${product.name}">
                    </a>
                </div>
            </div>
            <div class="description">
                <div class="product-brand">
                    <small class="product-brand">${product.brand}</small>
                </div>
                <h2 class="h4 article-title"><a href="/p/${product.slug}/${product.id}">${product.name}</a></h2>
                <div class="price">
                    ${(product.consumer_price ? `<span class="price-standard">${product.consumer_price}</span>` : '' )}
                    <span class="price-sales">${(product.sale_price ? product.sale_price : '')}</span>
                    ${js_translations.shop_DE == true ? `<span class="price-tax">${js_translations.DE_taxprice_text}</span>` : ''}
                </div>
            </div>
            ${outletProduct ? `
                <form action="/xhr/basket/add/" method="POST" class="js-order-form order-form" data-js-ga-trigger="btn_add_to_cart_wishlist">
                    <input type="hidden" value="${product.id}" name="product">
                    <input type="hidden" value="1" name="quantity">
                    
                    <button class="btn btn-green" type="submit">
                        <i class="fal fa-plus"></i>
                        <i class="gorb gorb-winkelwagen-up2"></i>
                    </button>
                </form>
            `: ''}
        </div>
    </div>
    `
};

setTimeout(() => {
    initWishlist();
    showWishlistProducts();

    if (JSON.parse(storage.getItem(global.wishlistName)).products.length > 0) {
        $('.js-wishlist-link').append(createWishlistBadge(JSON.parse(storage.getItem(global.wishlistName)).products.length));
    } else {
        // deleteWishlistBadge();
    }

}, 300)

initLazyLoad();